webpackJsonp([267695594480457],{

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(33);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "Terms and Privacy Policy"
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Bitartic is dedicated to provide fun, educational and safe experiences for all children and adults alike who play our Games. By using or accessing the Services in any manner, you acknowledge that you accept the terms and policies outlined in this \u201CTerms and Privacy Policy\u201D document and you hereby consent that we collect, use and share your information in a way described below."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Introduction"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "The Bitartic official website at www.bitartic.com is intended for use by parents and Bitartic\u2019s various Games, applications, content and services (collectively the \u201CService\u201D) are intended for use by the whole family including young children with parental participation and supervision. Bitartic recognizes the importance of protecting any information collected from the users (each a \u201CUser\u201D or collectively, \u201CUsers\u201D) of its Service, and has adopted this Privacy Policy to inform its Users about the types of information Company gathers about a User online while using Company\u2019s Service, how Company may use that information, whether Company discloses it to anyone, and the choices a User has regarding use of and correction of the information."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "This Privacy Policy is part of the terms of Service which you, or if you have not reached the age of majority in your jurisdiction, a parent or other legal guardian must read, understand and accept on your behalf. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "What does This Privacy Policy Cover?"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "This privacy policy covers Company\u2019s treatment of personally identifiable information (\u201CPersonal Information\u201D) that Company gather\u2019s when User is accessing or using Service, but not to the practices of companies we do not own or control, or people that we do not manage."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Children\u2019s Personal Information"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "If you are under the age of 13, you may only use our Service and disclose Personal Information with your parent or guardian\u2019s express consent. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "If a Company Game or Service requires registration or Personal Information in other forms, the information for a child under 13 must be provided by his or her parent, legal guardian, or a teacher with parental consent for providing the Personal Information. By providing Personal Information, you certify that you are a parent, guardian, or teacher who is legally authorized to provide the information, and consent to be responsible for the child\u2019s use of the Game or Service."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "If Company learns that the Company has received Personal Information from a person under the age of 13, or adult who does not have legal authority to provide the information, Company will delete that information as soon as possible. If you believe that a person under the age of 13 has provided us personal information, please contact Company by email: support [at] bitartic.com. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Automatically collected user information "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "To be able to improve Company\u2019s website, Games and Services, Company gathers statistical information about the Users. Company does not automatically collect or store personally identifiable information about individual users. The statistical information that Company gathers contains, for example, average session length, malfunctions, and the number of daily users which helps Company in the development and improvement of new and ongoing Games and/or Service. The statistics also identify the country, state, or major city where the user is located. Company may share the statistics with Company\u2019s partners, but never in a manner that could allow an individual user to be identified."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Information that a User provides to Company"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Company receives and stores any information that User knowingly provides the Company. For example, through a registration process, Company may collect Personal Information such as User\u2019s name, email address, payment information, and third-party account credentials (for example, user login credentials for Facebook, other third party sites and/or our partners\u2019 technical portals integrated into our Games or Service). If User provides third-party account credentials to Company or otherwise sign in to the Service through a third party site or service, user must understand some content and/or information in those accounts (\u201CThird Party Account Information\u201D) may be transmitted into user account with the Company, and that Third Party Account Information transmitted to Company\u2019s Service is covered by this Privacy Policy. During the registration process Company may also collect information about your child, which you provide to us, such as your child\u2019s name, age, gender, number of children (boys and/or girls) in the family. Company does not collect personally identifiable information from your child directly, only information that you may provide to Company. Any such information about your child that you provide to Company is considered Personal Information for the purposes of this Privacy Policy. Certain information may be required to register with Company or to take advantage of some of Company\u2019s features."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Company may communicate with you if you\u2019ve provided Company the means to do so. For example, Company may send you promotional email offers, or email you about your use of Company\u2019s Service. If you do not want to receive emails from Company, please follow the unsubscribe instructions contained in the emails, or contact Company by email. Company\u2019s applications may deliver notifications to your device. You can disable these notifications in your device settings."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Cookies"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Cookies are alphanumeric identifiers that Company may transfer to your computer through your browser, to enable Company\u2019s systems to recognize your browser and tell Company how and when pages in Company\u2019s site are visited and by how many people. Company can use cookies to enhance visitors\u2019 experiences, to learn more about their use of the Website and to improve quality. Company cookies do not collect Personal Information or Children\u2019s Personal Information, and Company does not combine the general information collected through cookies with other Personal Information or Children\u2019s Personal Information to tell Company that who you are or what your screen name or email address is. Most browsers have an option for turning off the cookie feature. It is strongly recommended that you leave the cookies activated, because cookies enable you to take advantage of some of Company\u2019s Website\u2019s most attractive features. If third party links appear through advertisements on the Website, those third party sites may use cookies. This Privacy Policy covers the use of cookies by Company and does not cover the use of cookies by any advertisers or third parties."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Sharing of Personal Information"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Company does not rent or sell your Personal Information or Children\u2019s Personal Information to any third parties. Company only shares Children\u2019s Personal Information associated with your account directly with you to report on your child\u2019s performance and development while using our services. Company never share Children\u2019s Personal Information with any third party. Data (like performance in Games) is shared as anonymous comparisons, but not in a way that could allow identification of the child."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Affiliated Businesses that Company does not control: Company may become affiliated with other businesses and in certain situations, these businesses may sell items to you through the Website. In other situations, Company may provide Service, or sell products jointly with affiliated businesses. Company will not share your Children\u2019s Personal Information in connection with any commercial third party transaction or service. You can easily recognize when an affiliated business is associated with your transaction, and Company will share your adult\u2019s Personal Information that is related to such transactions with that affiliated business. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Agents: Company employs other companies and people to perform tasks on Company\u2019s behalf and may need to share your information with them to provide products or Service to you. These may include for example sending email, analyzing data and providing user Service. Unless Company tell you differently, Company\u2019s agents do not have any right to use Personal Information or Children\u2019s Personal Information that Company shares with them beyond what is necessary to assist the Company. You hereby consent to Company\u2019s sharing of Personal Information and Children\u2019s Personal Information for the above purposes. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "User profiles: User profile information including your user name, email address, and other information you enter (\u201CUser Submissions\u201D) may be displayed to other users to facilitate user interaction within the Website. Minors are not allowed to enter or upload User Submissions. If the registration process is completed correctly, no Children\u2019s Personal Information will ever be displayed to any third party through a User profile. Email addresses are used to add new User Submissions to user profiles and to communicate through User Submissions. Users\u2019 email addresses will not be directly revealed to Company\u2019s or Service\u2019s other users, except, when the user is \"connected\" to another user via a shared group membership, or an invitation, or if the user has chosen to include their email address in their User Profile. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Communication about the Website or in response to User Submissions: As part of the website and Service, Company may send you email and other communication relating to your child\u2019s progress and use of the Service or User Submissions. You acknowledge and agree that by allowing your child to use the website and Service, and by posting such User Submissions, Company may send you email and other communication that it determines in its sole discretion relate to such activity and your User Submissions. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Promotional Offers: Company may send offers to you on behalf of other businesses. However, if Company does so, Company will not give the other business your name and address. If you do not wish to receive these offers, please send an email with your request to Company. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Business Transfers: In some cases, Company may choose to buy or sell assets. In these types of transactions, customer information is typically one of the business assets that are transferred. Moreover, if Company, or substantially all of its assets were acquired, or in the unlikely event that Company goes out of business or enters bankruptcy, customer information would be one of the assets that is transferred or acquired by a third party. You acknowledge that such transfers may occur, and that any acquirer of Company may continue to use your Personal Information and Children\u2019s Personal Information as set forth in this policy. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Protection of Company and Others: Company may release Personal Information when Company believes in good faith that release is necessary to comply with the law; enforce or apply Company\u2019s conditions of use and other agreements; or protect the rights, property, or safety of Company, employees, Users or others."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "With Your Consent: Except as set forth above, you will be notified when your Personal Information may be shared with third parties, and will be able to prevent the sharing of this information."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Security of Personal Information"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Your account is protected by a password for your privacy and security. If you access your account via a third party site or service, you may have additional or different sign-on protections via that third party site or service. You must prevent unauthorized access to your account and Personal Information by selecting and protecting your password and/or other sign-on mechanism appropriately and limiting access to your computer or device and browser by signing off after you have finished accessing your account."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Company endeavors to protect the privacy of your account and other Personal Information Company holds in our records, but Company cannot guarantee complete security. Unauthorized entry or use, hardware or software failure, and other factors, may compromise the security of user information at any time."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Access to Personal Information"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Through your account settings, you may view and, in some cases, edit or delete the information that you have provided to Company. This information may change as Company Service change, but is likely to include: ",
	      _react2.default.createElement("br", null),
	      "\u2022 name and password",
	      _react2.default.createElement("br", null),
	      "\u2022 email address",
	      _react2.default.createElement("br", null),
	      "\u2022 location",
	      _react2.default.createElement("br", null),
	      "\u2022 User profile information, including the name, age and gender of your child",
	      _react2.default.createElement("br", null),
	      "\u2022 Third Party account credentials"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "If you update or remove your information, it is possible that some of the original information remains in Company\u2019s records afterwards."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "If you have any questions about viewing or updating information that Company has about you and/or your child, please contact Company by email. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "As a user, what choices do I have?"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "You can opt not to disclose information to Company, but some information may be needed to register with Company or to take advantage of some of the features."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Advertisements and links"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Company\u2019s Games do not contain any banner ads of third party games and/or content. Redirection to external links for example Facebook, Twitter and other links are always under a parents section of Company\u2019s Games with parental gate and thus always child-protected. Company\u2019s Games might have safe advertisements of our own Games or our publishing partner\u2019s Games. Games do not contain possibilities for accidental purchases unless clearly stated in the Game description."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Third-Party Data Collection and Use of End-User Information"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "When you use or connect to Website or download Company\u2019s Game or application by or through a Third Party Platform you allow Company to access and/or collect information from your Third Party Platform profile and / or account. You additionally allow Company to access information contained in cookies placed on your device by the Third Party Platform as permitted by the terms of your agreement and privacy settings with the Third Party Platform. Company may share this information with the Third Party Platform for their use, as permitted by the terms of your agreement and privacy settings with the Third Party Platform.",
	      _react2.default.createElement("br", null),
	      "Company will share some of the statistics that Company collects from you with vendors and other service providers who work with Company to support the internal operations of Website and/or Services and / or application. For example, Company uses a third-party service for application data analytics. Company\u2019s third-party analytics company never sends emails, notifications, or other communications to users unless otherwise agreed between Company and user. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Changes to this Privacy Policy"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement("br", null),
	      "Company may revise this Privacy Policy from time to time. Use of information that Company collects now is subject to the Privacy Policy in effect at the time such information is used. If Company makes changes in the way Company uses Personal Information or Children\u2019s Personal Information, Company will notify you by posting an announcement on Website and/or on respective App Stores. The most current version of the policy will govern Company\u2019s use of your information. By continuing to access or use the Service after those changes become effective, you agree to be bound by the revised Privacy Policy."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement("br", null)
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Questions or Concerns",
	      _react2.default.createElement("br", null)
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        "b",
	        null,
	        "If you have any questions or concerns regarding privacy, please send a detailed email at support [at] bitartic.com. Company will make every effort to resolve your concerns."
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Bitartic Oy, Riippakatu 21, 33820 Tampere, Finland. "
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Last updated: 12",
	      _react2.default.createElement(
	        "sup",
	        null,
	        "th"
	      ),
	      " October 2017"
	    ),
	    _react2.default.createElement("br", null)
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-js-1e750a73cb00ff26f516.js